import styled, { useTheme } from 'styled-components';

interface LogoProps {
  variant?: 'light' | 'dark' | 'auto';
  size?: number;
}

const Wrapper = styled.span<{ $color: string; $size: number }>`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: ${({ $color }) => $color};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 700;
  font-size: ${({ $size }) => $size}px;
  letter-spacing: -0.01em;
  line-height: 1;
`;

const Mark = styled.span<{ $bg: string; $fg: string; $size: number }>`
  width: ${({ $size }) => $size * 1.15}px;
  height: ${({ $size }) => $size * 1.15}px;
  border-radius: 11px;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: ${({ $size }) => $size * 0.7}px;
  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.08);
`;

export const Logo = ({ variant = 'auto', size = 22 }: LogoProps) => {
  const theme = useTheme();
  const resolved =
    variant === 'auto' ? (theme.mode === 'dark' ? 'light' : 'dark') : variant;

  const wordmarkColor = resolved === 'light' ? '#ffffff' : theme.colors.textPrimary;
  const markBg = resolved === 'light' ? '#ffffff' : theme.colors.primary;
  const markFg = resolved === 'light' ? theme.colors.primary : '#ffffff';

  return (
    <Wrapper $color={wordmarkColor} $size={size} aria-label="Vendepay">
      <Mark $bg={markBg} $fg={markFg} $size={size} aria-hidden="true">
        V
      </Mark>
      <span>
        vende<strong style={{ fontWeight: 800 }}>pay</strong>
      </span>
    </Wrapper>
  );
};
